const companyInfoStep = {
  title: "Company information",
  parentCompanyTitle: "Parent Company",
  parentCompanyHint:
    "Please select the parent company under which you are applying to the Digital Experience program",
  yourCompanyTitle: "Your company information",
  yourCompanyAddressTitle: "Your company address",
  useParentCompanyAddressOption: "Use parent company address",
  registerDifferentSubsidiaryAddressOption:
    "I want to register a different company address for my subsidiary",
  parentAddressPreviewPlaceholder:
    "Select a parent company above to see its address here.",
  companyAddressSectionTitle: "Company address",
  additionalInfoTitle: "Additional information",
  companyDescriptionHint:
    "Hint: It's okay to copy and paste this from your company website.",
  fieldLabels: {
    companyName: "Company name",
    website: "Company website URL",
    phone: "Phone",
    linkedin: "LinkedIn profile URL",
    primaryBusiness: "How would you best describe your company?",
    ownership: "What best describes your company's ownership model?",
    totalEmployees: "Number of employees (company-wide)",
    referredBy:
      "Do you have a referral from an Adobe employee? If yes, please enter their email address.",
    hqAddress: "Address of company headquarters",
    country: "Country/Region",
    state: "State",
    city: "City",
    zipCode: "Zip Code",
    companyDescription: "Detailed company description",
    programBenefits:
      "How do Adobe Digital Experience applications benefit your business?",
  },
} as const;

export type CompanyInfoStepContent = typeof companyInfoStep;
export default companyInfoStep;
